import React from 'react';
import './Contact.css';
import {Element} from 'react-scroll';
import {useFormik } from 'formik';
import * as Yup from 'yup';

function Contact(){
   const formik=useFormik({
     initialValues: {
      username:"",
      email:"",
      message:""
     },
     validationSchema:Yup.object({
          username:Yup.string()
          .required("Name is required")
          .min(3,"Minimum number is above 3 characters")
          .max(15,"maximum number is 15 characters only")
          .strict()
          .trim(),
          email:Yup.string()
          .email()
          .required("Required email"),
          message:Yup.string()
          .required("Message is required")
          .min(30,"Minimum above 30 character ")
          .max(500, "maximum 500 characters are allowed")
     }),
    onSubmit:(userInput)=>{
      console.log(userInput);
    }
   })
  return(
     <Element className='contact__container' id='contact'> 
        <div className='contact__heading'>
            <h1>contact me </h1>
            <p>Feel Free to Contact me. I'd love to hear from you!</p>
        </div>
        <form onSubmit={formik.handleSubmit}>
        <div className='contact-cen'>
        <div className='contact-fill'>
        <div className='contact-name'>
         
         <label htmlFor="username">
           Name
         </label>
          <input 
          autoComplete="off"
          id="username"
          type="text"
          name="username"
          className="forms-input"
          placeholder=" Enter Your UserName"
          onChange={formik.handleChange}
          value={formik.values.username}
          />
          {
          formik.errors.username ? 
          <div className="sms_align">{formik.errors.username}</div> : null
          }
        </div>
        <div className='contact-email'>
        <label htmlFor="email">
          Email
        </label>
         <input 
         autoComplete="off"
         id="email"
         type="email"
         name="email"
         className="forms-input"
         placeholder=" Enter Your Email"
         onChange={formik.handleChange}
         value={formik.values.email}
        />
         {
          formik.errors.email ? 
          <div className="sms_align">{formik.errors.email}</div> : null
          }
       </div>
       <div className='contact-message'>
         <div className="mes_align">
        <label className="mes_text" htmlFor="message" >
          Message
        </label>
        {
          formik.errors.message ? 
          <div className="sms_align">{formik.errors.message}</div> : null
          }
          </div>
        <textarea
        autoComplete="off"
         id="message"
         type="text"
         name="message"
         className="forms-input"
         placeholder=" Write Your Message"
         onChange={formik.handleChange}
         value={formik.values.message}/>
       </div >
       <button className='contact-btn' >send</button>
       </div>
       </div>
      </form>
      </Element>
  )
}
export default Contact;
